// removed by extract-text-webpack-plugin
module.exports = {"container":"reports__container___8OSiY"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/reports/reports.scss
// module id = 1351
// module chunks = 0